import gql from "graphql-tag";

export function productListQuery(params) {
    return {
        query: gql`
            query($searchText: String!, $type: TITLE_TYPE, $sort: Sort, $limit: Int, $offset: Int) {
                result: productSearch(title: $searchText, type: $type, sort: $sort, limit:  $limit, offset: $offset) {
                    ... on PartialFeature {
                        id
                        title
                        type
                    }

                    ... on PartialSeason {
                        id
                        title
                        type
                    }
                }
            }
        `,
        variables: params,
    };
}

export function productSynopsesQuery(params) {
    return {
        query: gql`
            query($id: ID!) {
                result: product(id: $id) {
                    ... on Feature {
                            shortSynopsis
                            mediumSynopsis
                            fullSynopsis
                        }
                    ... on Season {
                            series {
                                shortSynopsis
                                mediumSynopsis
                                fullSynopsis
                            }
                    }
                }
            }
        `,
        variables: params,
    };
}

export function productMetadataQuery(params) {
    return {
        query: gql`
            query($id: ID!) {
                result: product(id: $id) {
                    title
                    type
                    legalTitle
                    lastModified
                    lastModifiedBy
                    locked
                    eidr
                    l2Eidr

                     ... on Feature {
                      genres
                      videoType
                      countryOfOrigin
                      copyright
                      mpmProductId
                      radarProductId
                      productionStudios
                      radarRating
                    }

                    ... on Season {
                      genres
                      mpmProductId
                      radarProductId
                      episodes {
                        id
                        title
                        episodeNumber
                      }
                    }
                }
            }
        `,
        variables: params,
    };
}

export function seriesMetadataQuery(params) {
    return {
        query: gql`
            query($id: ID!) {
                result: product(id: $id) {
                    ... on Season {
                      series {
                        legalTitle
                        lastModified
                        lastModifiedBy
                        videoType
                        countryOfOrigin
                        originalSpokenLanguage
                        productionStudios
                        mpmFamilyId
                        radarGroupId
                      }
                    }
                }
            }
        `,
        variables: params,
    };
}
